import { render, staticRenderFns } from "./fieldImage.vue?vue&type=template&id=54a1880e&"
import script from "./fieldImage.vue?vue&type=script&lang=js&"
export * from "./fieldImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/bsx-uat.dianthus.com.tw/backstage_orig/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54a1880e')) {
      api.createRecord('54a1880e', component.options)
    } else {
      api.reload('54a1880e', component.options)
    }
    module.hot.accept("./fieldImage.vue?vue&type=template&id=54a1880e&", function () {
      api.rerender('54a1880e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/vueFormFieldComponents/fieldImage.vue"
export default component.exports